import { LazyLoadImage } from 'react-lazy-load-image-component';

import { wbAssetImageUrl } from '../../lib/wb-asset/index.js';

export const WbAssetImage = ({
  children,
  publicId,
  uuid,
  className,
  draggable,
  style,
  alt,
  imageType,
  transformation = {},
}) => {
  return (
    <LazyLoadImage
      src={wbAssetImageUrl({ publicId, uuid, imageType, transformation })}
      className={className}
      draggable={draggable}
      style={style}
      alt={alt}
    >
      {children}
    </LazyLoadImage>
  );
};
